/**
 * Layout constants for the TimelineGroupHeader.
 *
 * Kept in a non-component module so the header component file exports only
 * React components (and types). eslint-plugin-react-refresh's
 * `only-export-components` rule flags non-literal value exports (this is a
 * member-expression, not a literal) when they sit beside a component, which
 * would break Fast Refresh boundaries. See shipcast-7i0.
 */

import { TIMELINE_LAYOUT } from '@/constants/timeline';

/** Height of the group header (same as a regular row) */
export const COLLAPSED_GROUP_HEIGHT = TIMELINE_LAYOUT.ROW_HEIGHT;
